import { AnalyticsScreen } from '@/components/analytics/AnalyticsScreen';

export function AnalyticsPage() {
  return <AnalyticsScreen />;
}
